<section class="overlay-panel-container">
  @if (openPanel) {
    <div class="overlay-panel-content" [@slideInRight]>
      <header class="d-flex justify-content-between align-items-center">
        <h5 class="text-primary font-weight-bold"> {{ 'ime.messages' | translate }} </h5>
        <button mat-icon-button (click)="close()"> <mat-icon>close</mat-icon> </button>
      </header>
    </div>
  }
</section>